import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/';
import { environment } from './environments/environment';
import './polyfills.ts';


if (environment.production) {
  enableProdMode();
}

// getTranslationProviders().then(providers => {
//   const options = { providers };
//   platformBrowserDynamic().bootstrapModule(AppModule, options);
// });

platformBrowserDynamic().bootstrapModule(AppModule);
